import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { UtmifyScript } from './components/UtmifyScript';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { MaterialCarousel } from './components/MaterialCarousel';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-background font-sans text-foreground" data-id="element-0" data-mp="28sl5f2ubjwhm">
      <MetaPixel data-id="element-1" data-mp="23u9vyt7xrnzx" />
      <UtmifyScript data-id="element-2" data-mp="23utadzydnu97" />
      <CountdownBar data-id="element-3" data-mp="23ti8y6semyl9" />
      <main data-id="element-4" data-mp="3ik7fqfdqo9q4">
        <Hero data-id="element-5" data-mp="3ikh5c1uvgeva" />
        <StatsBar data-id="element-6" data-mp="3iiwfgpji5k3r" />
        <Difference data-id="element-7" data-mp="3ijfu9xduvsdk" />
        <Recognize data-id="element-8" data-mp="3ihuyy5jpw5en" />
        <WhatsInside data-id="element-9" data-mp="3mlawr57iwbsx" />
        <MaterialCarousel data-id="element-10" data-mp="3mkrc3gqhn9b7" />
        <Bonuses data-id="element-11" data-mp="3mjzuj9tq7c3x" />
        <Offer data-id="element-12" data-mp="3mjg8bgx1m1k3" />
        <Guarantee data-id="element-13" data-mp="3rc9du70c5dx8" />
        <Testimonials data-id="element-14" data-mp="3rbrayrj641gc" />
        <Faq data-id="element-15" data-mp="3rdatypw7kqlt" />
        <FinalCta data-id="element-16" data-mp="3rcswjpxt86cb" />
      </main>
      <Footer data-id="element-17" data-mp="3relwynhtxubv" />
    </div>;
}